import { useEffect, useState } from 'react';

export function useBufferingIndicator(isBuffering: boolean) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(isBuffering), 500);
    return () => clearTimeout(timeout);
  }, [isBuffering]);

  return visible;
}
